import { Component, OnInit, Input, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {DialogService} from '@rbaip/ui-component';
import {ErrorResponseMessage} from '@rbaip/ui-component';
import {Address, Contact} from '@rbaip/address-form';
import {Asset} from '../../shared/domain/item';
import {ItemSummaryContactInfoService} from '../../shared/contact/item-summary-contact-info.service';

@Component({
  selector: 'lib-item-summary-contact-edit',
  templateUrl: './contact-edit.component.html',
  styleUrls: ['./contact-edit.component.scss']
})
export class ContactEditComponent implements OnInit {

  @Input() editing: boolean;
  @Input() contact: Contact;
  @Input() contactType: string;
  @Input() updateService: ItemSummaryContactInfoService;
  @Input() asset: Asset;

  public successMessage = '';
  public errorMessage = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private dialogRef: MatDialogRef<ContactEditComponent>,
              private dialogService: DialogService) {
    if (data) {
      this.editing = data.editing;
      this.contact = data.contact;
      this.contactType = data.contactType;
      this.updateService = data.updateService;
      this.asset = data.asset;
    }
  }

  ngOnInit() {

  }

  consumeAddressChanged(updatedAddress: Address): void {
    this.resetSuccessMessage();
    this.resetErrorMessage();
    this.contact.updateAddressBasedOnGooglePlacesAddress(updatedAddress);
  }

  public saveContact() {
    this.resetSuccessMessage();
    this.resetErrorMessage();
    this.dialogService.showProgress();
    const eventId = this.asset.auctionEventId;
    const equipId = this.asset.equipId;
    this.updateService.saveContact(eventId, equipId, this.contact, this.contactType)
      .subscribe(response => {
        response = response as ErrorResponseMessage;
        if (response && response.error) {
          this.errorMessage = response.getErrorMessage() ? response.getErrorMessage() : 'Failed to save contact info!';
        } else {
          this.successMessage = 'Successfully saved contact info!';
          this.dialogService.hideProgress();

          setTimeout(() => this.dialogRef.close(), 1000);
        }
      });
  }

  private resetSuccessMessage(): void {
    this.successMessage = '';
  }

  private resetErrorMessage(): void {
    this.errorMessage = '';
  }
}
